export default __webpack_public_path__ + "static/media/WHITE-ALPHA.bcadd928.webp";